import { BACKOFFICE } from '../constants/values';
import { selectCurrentUser } from '../features/auth/authSlice';
import { useAppSelector } from './reduxHooks';

export const useRoles = () => {
    const user = useAppSelector(selectCurrentUser);

    const isPerfilBackOffice = user?.perfil?.nombre === BACKOFFICE;

    const isAdminBO = user?.roles.some(
        (role) => role.nombre === 'ADMINISTRADOR_BACKOFFICE' && role.id === 1
    );
    const isSupervisorSIMP = user?.roles.some(
        (role) => role.nombre === 'SUPERVISOR_SIMP' && role.id === 2
    );
    const isOperatorSIMP = user?.roles.some(
        (role) => role.nombre === 'OPERADOR_SIMP' && role.id === 3
    );
    const isViewerBO = user?.roles.some(
        (role) => role.nombre === 'ASEGURADORA_VIEWER' && role.id === 4
    );

    const isRRHHSIMP = user?.roles.some((role) => role.nombre === 'RRHH_SIMP' && role.id === 5);

    const isPreventor = user?.roles.some((role) => role.nombre === 'PREVENTOR' && role.id === 6);

    const checkPathPrefix = () => {
        if (isSupervisorSIMP || isOperatorSIMP || isRRHHSIMP) {
            return 'simp';
        }

        if (isAdminBO || isViewerBO || isPreventor) {
            return 'backoffice';
        }

        return 'prefixNotFound';
    };

    const isSIMP = isSupervisorSIMP || isOperatorSIMP || isRRHHSIMP;
    const isBO = isAdminBO || isViewerBO || isPreventor;


    const pathPrefix = checkPathPrefix();

    let auth = {
        isAdmin: false,
        role: ''
    };

    const admin = user?.roles?.find(
        (rol: any) =>
            rol.nombre === 'ADMINISTRADOR_MANAGER' || rol.nombre === 'ADMINISTRADOR_VIEWER'
    );

    if (admin) {
        auth.isAdmin = true;
        auth.role = 'admin';
    } else {
        user?.roles?.forEach((rol: any) => {
            if (rol.nombre === 'AGENCIA_MANAGER' || rol.nombre === 'AGENCIA_VIEWER') {
                auth.role = 'agencia';
            }
            if (
                rol.nombre === 'AGENCIA_FERROVIARIA_MANAGER' ||
                rol.nombre === 'AGENCIA_FERROVIARIA_VIEWER'
            ) {
                auth.role = 'agencia FFCC';
            }
            if (rol.nombre === 'TERMINAL_MANAGER' || rol.nombre === 'TERMINAL_VIEWER') {
                auth.role = 'terminal';
            }
            if (rol.nombre === 'BACKOFFICE_MANAGER') {
                auth.role = 'backoffice';
            }
            if (rol.nombre === 'PREFECTURA_MANAGER') {
                auth.role = 'prefectura';
            }
            if (rol.nombre === 'ADUANA_MANAGER') {
                auth.role = 'aduana';
            }
            if (rol.nombre === 'LIQUIDADOR_MANAGER') {
                auth.role = 'liquidador';
            }
        });
    }

    const { isAdmin, role } = auth;
    return {
        isAdmin,
        role,
        isAdminBO,
        isSupervisorSIMP,
        isOperatorSIMP,
        isSIMP,
        isBO,
        pathPrefix,
        isViewerBO,
        isRRHHSIMP,
        isPreventor,
        isPerfilBackOffice
    };
};
